import { render, staticRenderFns } from "./SimpleHeader.vue?vue&type=template&id=5d196f65&scoped=true"
import script from "./SimpleHeader.vue?vue&type=script&lang=js"
export * from "./SimpleHeader.vue?vue&type=script&lang=js"
import style0 from "./SimpleHeader.vue?vue&type=style&index=0&id=5d196f65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d196f65",
  null
  
)

export default component.exports